import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { DocumentType, PurchaseOrderTransition } from '@synergy/models';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { ConvertOutcome, NOTHING_CREATED } from './models/convert-outcome';
import { DemandTransition } from './models/demand/demandTransition';
import { OfferTransition } from './models/offer/offerTransition';
import { SalesOrderTransition } from './models/sales-order/salesOrdersTransition';
import { receiveInquiry } from '../inquiries/inquiry-actions';
import { receivePurchaseOrder } from '../purchase-orders/purchase-order-actions';

export const DEMAND_TO_INQUIRIES_TRANSITION = 'DEMAND_TO_INQUIRIES_TRANSITION';
export const DEMAND_TO_PURCHASE_ORDERS_TRANSITION = 'DEMAND_TO_PURCHASE_ORDERS_TRANSITION';
export const INQUIRY_TO_PURCHASE_ORDERS_TRANSITION = 'INQUIRY_TO_PURCHASE_ORDERS_TRANSITION';
export const PURCHASE_ORDER_INTO_CREDIT_TRANSITION = 'PURCHASE_ORDER_INTO_CREDIT_TRANSITION';
export const PURCHASE_ORDER_INTO_INVOICE_TRANSITION = 'PURCHASE_ORDER_INTO_INVOICE_TRANSITION';
export const SALES_ORDER_TO_INQUIRIES_TRANSITION = 'SALES_ORDER_TO_INQUIRIES_TRANSITION';
export const SALES_ORDER_TO_PURCHASE_ORDERS_TRANSITION = 'SALES_ORDER_TO_PURCHASE_ORDERS_TRANSITION';

export const inquiryPurchaseOrdersTransition = () => {
    return {
        type: INQUIRY_TO_PURCHASE_ORDERS_TRANSITION,
    };
};

export const salesOrderPurchaseOrdersTransition = () => {
    return {
        type: SALES_ORDER_TO_PURCHASE_ORDERS_TRANSITION,
    };
};

export const salesOrderInquiriesTransition = () => {
    return {
        type: SALES_ORDER_TO_INQUIRIES_TRANSITION,
    };
};

export const demandPurchaseOrdersTransition = () => {
    return {
        type: DEMAND_TO_PURCHASE_ORDERS_TRANSITION,
    };
};

export const demandInquiriesTransition = () => {
    return {
        type: DEMAND_TO_INQUIRIES_TRANSITION,
    };
};

export const purchaseOrderInvoiceTransition = () => {
    return {
        type: PURCHASE_ORDER_INTO_INVOICE_TRANSITION,
    };
};

export const purchaseOrderCreditTransition = () => {
    return {
        type: PURCHASE_ORDER_INTO_CREDIT_TRANSITION,
    };
};

export const transitionInquiryIntoPurchaseOrders = (transitionObject: OfferTransition) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<ConvertOutcome> => {
        dispatch(inquiryPurchaseOrdersTransition());
        const response = await api.transitions.inquiryIntoPurchaseOrdersTransition(transitionObject);
        if (response.success) {
            response.result.forEach(purchaseOrder => {
                dispatch(receivePurchaseOrder(purchaseOrder));
            });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response.success
            ? {
                  created: response.result.map(document => ({
                      type: DocumentType.PurchaseOrder,
                      id: document.id,
                      number: document.number,
                  })),
                  failed: false,
              }
            : NOTHING_CREATED;
    };
};

export const transitionSalesOrderIntoPurchaseOrders = (transitionObject: SalesOrderTransition) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<ConvertOutcome> => {
        dispatch(salesOrderPurchaseOrdersTransition());
        const response = await api.transitions.salesOrderIntoPurchaseOrdersTransition(transitionObject);

        if (response.success) {
            response.result.forEach(purchaseOrder => {
                dispatch(receivePurchaseOrder(purchaseOrder));
            });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response.success
            ? {
                  created: response.result.map(document => ({
                      type: DocumentType.PurchaseOrder,
                      id: document.id,
                      number: document.number,
                  })),
                  failed: false,
              }
            : NOTHING_CREATED;
    };
};

export const transitionSalesOrderIntoInquiries = (transitionObject: SalesOrderTransition) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<ConvertOutcome> => {
        dispatch(salesOrderInquiriesTransition());
        const response = await api.transitions.salesOrderIntoInquiriesTransition(transitionObject);
        if (response.success) {
            response.result.forEach(inquiry => {
                dispatch(receiveInquiry(inquiry));
            });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response.success
            ? {
                  created: response.result.map(document => ({
                      type: DocumentType.Inquiry,
                      id: document.id,
                      number: document.number,
                  })),
                  failed: false,
              }
            : NOTHING_CREATED;
    };
};

export const transitionDemandIntoPurchaseOrders = (transitionObject: DemandTransition) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<ConvertOutcome> => {
        dispatch(demandPurchaseOrdersTransition());
        const response = await api.transitions.demandIntoPurchaseOrdersTransition(transitionObject);
        if (response.success) {
            response.result.forEach(purchaseOrder => {
                dispatch(receivePurchaseOrder(purchaseOrder));
            });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response.success
            ? {
                  created: response.result.map(document => ({
                      type: DocumentType.PurchaseOrder,
                      id: document.id,
                      number: document.number,
                  })),
                  failed: false,
              }
            : NOTHING_CREATED;
    };
};

export const transitionDemandIntoInquiries = (transitionObject: DemandTransition) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<ConvertOutcome> => {
        dispatch(demandInquiriesTransition());
        const response = await api.transitions.demandIntoInquiriesTransition(transitionObject);
        if (response.success) {
            response.result.forEach(inquiry => {
                dispatch(receiveInquiry(inquiry));
            });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response.success
            ? {
                  created: response.result.map(document => ({
                      type: DocumentType.Inquiry,
                      id: document.id,
                      number: document.number,
                  })),
                  failed: false,
              }
            : NOTHING_CREATED;
    };
};

export const transitionPurchaseOrderIntoInvoice = (transitionObject: PurchaseOrderTransition) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<ConvertOutcome> => {
        dispatch(purchaseOrderInvoiceTransition());

        const transitionObjectCopy = {
            ...transitionObject,
            purchaseOrderItems: transitionObject.purchaseOrderItems.filter(item => !item.type),
            surchargeItems: transitionObject.purchaseOrderItems?.filter(item => !!item.type),
        };

        const response = await api.transitions.purchaseOrderIntoInvoiceTransition(transitionObjectCopy);
        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.transitionCreated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response.success
            ? {
                  created: response.result.map(document => ({
                      type: DocumentType.Invoice,
                      id: document.id,
                      number: document.number,
                  })),
                  failed: false,
              }
            : NOTHING_CREATED;
    };
};

export const transitionPurchaseOrderIntoCredit = (transitionObject: PurchaseOrderTransition) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }): Promise<ConvertOutcome> => {
        dispatch(purchaseOrderCreditTransition());
        const response = await api.transitions.purchaseOrderIntoCreditTransition(transitionObject);
        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.transitionCreated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return response.success
            ? {
                  created: response.result.map(document => ({
                      type: DocumentType.Credit,
                      id: document.id,
                      number: document.number,
                  })),
                  failed: false,
              }
            : NOTHING_CREATED;
    };
};
